import { COLORS } from '@mafc/common';
import { Button, customStyled, Box, Text } from '@mafc/trolly';

export const ShipmentCardFooter = customStyled(Box)(() => ({
  paddingTop: 0,
  borderTop: 'none',
}));

export const ShipmentSubTotal = customStyled(Text)(props => ({
  color: COLORS.BLACK,
  fontSize: `${props.theme.fontSizes[3]}px`,
  fontWeight: props.theme.fontWeights[6],
}));

export const ShipmentSubTotalLabel = customStyled(Text)(props => ({
  color: COLORS.BLACK,
  fontSize: `${props.theme.fontSizes[2]}px`,
  fontWeight: props.theme.fontWeights[6],
}));

export const CheckoutButton = customStyled(Button)(props => ({
  padding: '10px 24px',
  fontSize: `${props.theme.fontSizes[2]}px`,
  fontWeight: props.theme.fontWeights[6],
  borderWidth: '2px',
  borderRadius: `${props.theme.radii[3]}px`,
  textTransform: 'none',
}));
